import angular from 'angular';

import appSettingsModule from '../../../../app.settings.module';

import ProductDeleteModalController from './product.delete.modal.controller';
import ProductsController from './products.controller';
import ProductCreateController from './products.create.controller';
import ProductDetailController from './products.detail.controller';
import ProductService from './products.service';

const productsModule = angular.module('admin.assets.products', [
	appSettingsModule
]);

productsModule
	.controller('ProductDeleteModalController', ProductDeleteModalController)
	.controller('ProductsController', ProductsController)
	.controller('ProductCreateController', ProductCreateController)
	.controller('ProductDetailController', ProductDetailController)

	.service('productService', ProductService);

export default productsModule.name;
